import axios from 'axios';
import globals from "../config/appconfig";

export default class PazientiService {

    static urlPazienti = globals["app-url-backend-anagrafica"] + "/anagrafiche"
    static urlLetturaPaziente = globals["app-url-backend-anagrafica"] + "/pazienti/{idPaziente}"
    static urlInserimentoPaziente = globals["app-url-backend-anagrafica"] + "/pazienti"

    static getPazienti(params) {

        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlPazienti + querystring)
    }

    static letturaPaziente(idPaziente) {

        return axios.get(this.urlLetturaPaziente.replace("{idPaziente}", idPaziente))

    }

    static postInserimentoPaziente(jsonInsert) {

        return axios.post(this.urlInserimentoPaziente, jsonInsert)

    }

    static putInserimentoPaziente(jsonInsert) {

        return axios.put(this.urlInserimentoPaziente, jsonInsert)

    }

    static putModificaPazienteAnagrafe(idAnagrafica, jsonInsert) {

        return axios.put(this.urlLetturaPaziente.replace("{idPaziente}", idAnagrafica), jsonInsert)

    }

}
